import './styles.scss';
import {Button, Card, Col, Empty, FloatButton, Form, message, Row, Select, Spin, Tag, theme, Timeline} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSackDollar,} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import '../transactionHistory/styles.scss';
import {invest_title_img} from "../../../AppImageConst";
import {useHistory, useLocation} from "react-router-dom";
import {DashboardWrapperDto} from "../../dto/DashboardWrapperDto";
import {
    getManagerCode,
    getRmCode,
    getUserInfo,
    isAdminUser,
    isManagerUser,
    isRelationshipManagerUser
} from "../../security/KeyclockConfig";
import ErrorHandler from "../../util/ErrorHandler";
import customerService from "../../service/customerService";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {ACCOUNT_TYPE, CUSTOMER_VERIFICATION_STATUS, NOT_AVAILABLE} from "../../util/Constants";
import PendingChangeRequest from "../../components/customerDashboard/pendingChangeRequest";
import TransactionSummary from "../../components/customerDashboard/transactionSummary";
import AccountCardCarousal from "../../components/customerDashboard/accountCardCarousal";
import {
    MSG_FAILED_TO_FETCH_CUSTOMER_VERIFICATION_STATUSES_ERROR,
    MSG_FAILED_TO_FETCH_DASHBOARD_DATA_ERROR,
    MSG_FAILED_TO_FETCH_PORTFOLIO_WISE_FUND_LIST_ERROR,
    MSG_FAILED_TO_FETCH_TOTAL_WEALTH_ERROR
} from "../../util/Messages";
import {DataItem} from "@antv/data-set/lib/transform/tag-cloud";
import {CustomerVerificationStatusDto} from "../../dto/CustomerVerificationStatusDto";
import {FileDoneOutlined, UserOutlined, VideoCameraOutlined} from "@ant-design/icons";
import CommonFunction from "../../util/CommonFunction";
import modal from "antd/es/modal";
import {useKeycloak} from "@react-keycloak/web";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {CurrentYieldDetailDto} from "../../dto/admin/CurrentYieldDetailDto";
import GoogleChart from "../../components/customerDashboard/googleChart";

const DashboardPage = () => {
    const history = useHistory();
    const {keycloak} = useKeycloak();
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const location = useLocation();
    const [dashboardData, setDashboardData] = useState<DashboardWrapperDto>({
        accountCardDetails: [], cinNumber: ''
    })
    const [totalWealthAndCurrentYield, setTotalWealthAndCurrentYield] = useState<{
        currentYieldDto: CurrentYieldDetailDto,
        totalWealth: number
    }>()
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isVerificationFailed, setVerificationFailed] = useState<boolean>(true);
    const [isTotalWealthLoading, setTotalWealthLoading] = useState<boolean>(false);
    const [isNoData, setNoData] = useState<boolean>(false);
    const [isCardLoading, setCardLoading] = useState<boolean>(false);
    const [isPieChartLoading, setPieChartLoading] = useState<boolean>(false);
    const [loadingMessage, setLoadingMessage] = useState<string>("Loading...");
    const [customerId, setCustomerId] = useState<number>(0);
    const [fundData, setFundData] = useState<DataItem[]>([])
    const [verificationStatuses, setVerificationStatuses] = useState<CustomerVerificationStatusDto>()
    const [portfolioNumberList, setPortfolioNumberList] = useState<DropdownListDto[]>([]);
    const [portfolioId, setPortfolioId] = useState("0")
    const [accountNumber, setAccountNumber] = useState<string>("")
    const [form] = Form.useForm();
    const [selectedPortfolioId, setSelectedPortfolioId] = useState<number | null>(null);
    const [isAllZero, setIsAllZero] = useState(false);
    const {useToken} = theme;
    const {token} = useToken();
    useEffect(() => {
        setIsLoading(true)
        setPieChartLoading(true)
        setTotalWealthLoading(true)
        setLoadingMessage("Loading...")
        getUserInfo().then((userInfo: any) => {
            if (isAdminUser()) {
                history.push('/workflow/admin/dashboard')
            } else if (isManagerUser()) {
                localStorage.setItem("managerCode", getManagerCode())
                history.push(`/workflow/admin/manager-dashboard`)
            } else if (isRelationshipManagerUser()) {
                localStorage.setItem("rmCode", getRmCode())
                history.push(`/workflow/admin/relationship-manager-dashboard`)
            } else {
                getCustomerDataByUsername(userInfo.preferred_username)
            }
            // adminService.verifyAdminByUsername(userInfo.preferred_username).then((res) => {
            //     if (!res.data.results.admin) {
            //         getCustomerDataByUsername(userInfo.preferred_username)
            //     } else {
            //         history.push('/workflow/admin/dashboard')
            //     }
            // }).catch((reason) => {
            //     ErrorHandler.handleError(reason);
            // });

        });

    }, [])

    const fetchCustomerPortfolioNumbers = (customerId: number) => {
        fetchCustomerVerificationStatuses(customerId)
        const {portfolioId} = location.state || {};
        customerService.fetchCustomerWisePortfolios(customerId).then((res: any) => {
            if (res.data !== null && res.data.results.length > 0) {
                let results = res.data.results;

                setPortfolioNumberList(results)

                setSelectedPortfolioId(null)
                // const initiallySelected = results.find((p: DropdownListDto) => p.value.isSelectedPortfolio);
                // if (initiallySelected) {
                //     setSelectedPortfolioId(initiallySelected.value.portfolioId);
                //     form.setFieldsValue({portfolioId: initiallySelected.value.portfolioId})
                //     fetchCustomerWisePortfolioCard(initiallySelected.value.portfolioId, customerId)
                //     setAccountNumber(extractFirstPart(initiallySelected.label))
                //
                // }

                let selectedPortfolio = {} as DropdownListDto;
                if (portfolioId) {
                    selectedPortfolio = results.find((p: DropdownListDto) => extractFirstPart(p.label) === portfolioId);
                } else {
                    selectedPortfolio = results[0];
                }

                if (0 == selectedPortfolio.value.portfolioId) {
                    setSelectedPortfolioId(selectedPortfolio.value.portfolioId);
                    form.setFieldsValue({portfolioId: selectedPortfolio.value.portfolioId})
                    fetchCombinePortfolioCard(selectedPortfolio.value.portfolioId, customerId)
                    // setAccountNumber(extractFirstPart(selectedPortfolio.label))
                } else {
                    setSelectedPortfolioId(selectedPortfolio.value.portfolioId);
                    form.setFieldsValue({portfolioId: selectedPortfolio.value.portfolioId})
                    fetchCustomerWisePortfolioCard(selectedPortfolio.value.portfolioId, customerId)
                    setAccountNumber(extractFirstPart(selectedPortfolio.label))
                }

                setNoData(false)
                setIsLoading(false)
            } else {
                setIsLoading(false)
                setCardLoading(false)
                setTotalWealthLoading(false)
                setPieChartLoading(false)
                setNoData(true)
                message.error(MSG_FAILED_TO_FETCH_DASHBOARD_DATA_ERROR).then();
            }
        }).catch((reason) => {
            setIsLoading(false)
            setCardLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const onPortfolioIdChange = (portfolioId: number, data: DropdownListDto) => {
        if (0 == portfolioId) {
            fetchCombinePortfolioCard(portfolioId, customerId)
        } else {
            setAccountNumber(extractFirstPart(data.label))
            fetchCustomerWisePortfolioCard(portfolioId, customerId)
        }
        // saveSelectedCardAsDefault(portfolioId, customerId)
    }
    const extractFirstPart = (str: string) => {
        return str.split(' - ')[0];
    }
    const fetchCustomerWisePortfolioCard = (portfolioId: number, custId: number) => {
        setCardLoading(true)
        setPieChartLoading(true)
        customerService.fetchAccountCardDetail(custId, portfolioId).then((res: any) => {
            if (res.data !== null) {
                let results = res.data.results;

                setDashboardData(results)
                fetchTotalWealth(results.cinNumber)
                updateComp(portfolioId)

                setCardLoading(false)
            } else {
                setCardLoading(false)
                message.error(MSG_FAILED_TO_FETCH_DASHBOARD_DATA_ERROR).then();
            }
        }).catch((reason) => {
            setCardLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const fetchCombinePortfolioCard = (portfolioId: number, custId: number) => {
        setCardLoading(true)
        setPieChartLoading(true)
        customerService.fetchCombineAccountCardDetail(custId).then((res: any) => {
            if (res.data !== null) {
                let results = res.data.results;

                setDashboardData(results)
                fetchTotalWealth(results.cinNumber)
                fetchCinWiseFundDetails(results.cinNumber)
                setPortfolioId(String(portfolioId))
                setCardLoading(false)
            } else {
                setCardLoading(false)
                message.error(MSG_FAILED_TO_FETCH_DASHBOARD_DATA_ERROR).then();
            }
        }).catch((reason) => {
            setCardLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const saveSelectedCardAsDefault = (portfolioId: number, custId: number) => {
        customerService.saveSelectedPortfolioInDashboard(custId, portfolioId).then((res: any) => {
            if (res.data !== null) {
                console.log("Selected")
            } else {
                console.log("Failed")
            }
        }).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const getCustomerDataByUsername = (username: string) => {
        customerService.getCustomerByUserName(username).then((res: any) => {
            const customerWrapperDto: CustomerWrapperDto = res.data?.results
            if (customerWrapperDto.customerMstDto) {
                /**
                 * if !customerWrapperDto.isTimeSlotSelected means customer still not complete the on boarding
                 * process. so the system need to redirect customer to on boarding flow*/
                if (!customerWrapperDto.isTimeSlotSelected) {
                    //    redirect to on boarding process
                    setLoadingMessage("Redirecting...")
                    if (customerWrapperDto.customerMstDto.initialAccountTypeId === ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT) {
                        setTimeout(() => {
                            setIsLoading(false)
                            history.push("/create-individual-account")
                        }, 1000)

                    } else {
                        setTimeout(() => {
                            setIsLoading(false)
                            history.push("/create-joint-account")
                        }, 1000)

                    }
                } else {
                    if (customerWrapperDto.customerMstDto.id !== undefined) {
                        localStorage.setItem("cinNumber", customerWrapperDto.customerMstDto.cin as string)

                        // getDashboardData(customerWrapperDto.customerMstDto.id)
                        setCustomerId(customerWrapperDto.customerMstDto.id)
                        fetchCustomerPortfolioNumbers(customerWrapperDto.customerMstDto.id)
                    }
                }
            } else {
                setLoadingMessage("Redirecting...")
                setTimeout(() => {
                    setIsLoading(false)
                    history.push("/account-type-selection")
                }, 1000)
            }
        }).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }
    //
    // const getDashboardData = (customerId: number) => {
    //     if (null != customerId) {
    //         fetchCustomerVerificationStatuses(customerId)
    //         customerService.getDashboardData(customerId).then(res => {
    //             if (res.data !== null) {
    //                 let results = res.data.results;
    //                 setDashboardData(results)
    //                 fetchTotalWealth(results.cinNumber)
    //                 updateComp(results.accountCardDetails[0].accountNumber)
    //                 if (results.accountCardDetails[0].accountNumber !== null) {
    //                     setPortfolioId(results.accountCardDetails[0].accountNumber)
    //                 }
    //                 setIsLoading(false)
    //             } else {
    //                 setIsLoading(false)
    //                 message.error(MSG_FAILED_TO_FETCH_DASHBOARD_DATA_ERROR).then();
    //             }
    //         }).catch(reason => {
    //             setIsLoading(false)
    //             ErrorHandler.handleError(reason);
    //         })
    //     }
    // }

    const fetchTotalWealth = (cinNumber: string) => {
        if (null != cinNumber) {
            customerService.fetchTotalWealth(cinNumber).then(res => {
                if (res.data !== null) {
                    setTotalWealthAndCurrentYield(res.data.results)
                    setTotalWealthLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_TOTAL_WEALTH_ERROR).then();
                    setTotalWealthLoading(false)
                }
            }).catch(reason => {
                ErrorHandler.handleError(reason);
                setTotalWealthLoading(false)
            })
        } else {
            setTotalWealthLoading(false)
        }
    }

    const updateComp = (portfolioValue: number) => {
        if (null != portfolioValue) {
            setPieChartLoading(true)
            fetchFundDetails(String(portfolioValue))
            setPortfolioId(String(portfolioValue))
        }
    }

    const onSecondApplicantEdit = () => {
        setCardLoading(true)
        fetchCustomerPortfolioNumbers(customerId)
    }

    const fetchFundDetails = (portfolioValue: string) => {
        if (null !== portfolioValue && undefined != portfolioValue) {
            customerService.getPortfolioWiseFundDetails(portfolioValue).then(res => {
                if (res.data !== null) {
                    setFundData([])
                    setIsAllZero(res.data.results.every(item => item.value === 0));

                    setFundData(res.data.results)
                    setPieChartLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_WISE_FUND_LIST_ERROR).then();
                    setPieChartLoading(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setPieChartLoading(false)

            })
        } else {
            setFundData([])
        }
    }

    const fetchCinWiseFundDetails = (cinNumber: string) => {
        if (null !== cinNumber && undefined != cinNumber) {
            customerService.getCinWiseFundDetails(cinNumber).then(res => {
                if (res.data !== null) {
                    setFundData([])
                    setIsAllZero(res.data.results.every(item => item.value === 0));

                    setFundData(res.data.results)
                    setPieChartLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_PORTFOLIO_WISE_FUND_LIST_ERROR).then();
                    setPieChartLoading(false)

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setPieChartLoading(false)

            })
        } else {
            setFundData([])
            setPieChartLoading(false)
        }
    }

    const fetchCustomerVerificationStatuses = (customerId: number) => {
        if (null !== customerId && undefined != customerId) {
            customerService.getCustomerVerificationStatuses(customerId).then(res => {
                if (res.data !== null) {
                    let results = res.data.results;
                    setVerificationFailed(false)
                    setVerificationStatuses(results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_CUSTOMER_VERIFICATION_STATUSES_ERROR).then();

                }
            }, (reason) => {
                ErrorHandler.handleError(reason);

            })
        } else {
            setFundData([])
        }
    }

    const navigateToInvest = () => {
        history.push("/workflow/customer/invest-request")
    }

    const getTag = (status: string | undefined) => {
        if (undefined != status) {
            if (CUSTOMER_VERIFICATION_STATUS.PENDING == status) {
                return (<Tag className={'time-line-pending-tag'}>Pending</Tag>);
            } else if (CUSTOMER_VERIFICATION_STATUS.VERIFIED == status) {
                return (<Tag className={'time-line-success-tag'}>Verified</Tag>);
            } else if (CUSTOMER_VERIFICATION_STATUS.RESCHEDULED == status) {
                return (<Tag className={'time-line-rescheduled-tag'}>Rescheduled</Tag>);
            } else if (CUSTOMER_VERIFICATION_STATUS.DECLINED == status) {
                return (<Tag className={'time-line-declined-tag'}>Declined</Tag>);
            } else if (CUSTOMER_VERIFICATION_STATUS.ORIGINALLY_SEEN == status) {
                return (<Tag className={'time-line-success-tag'}>Originally Seen</Tag>);
            } else {
                return (<Tag className={'time-line-rejected-tag'}>Rejected</Tag>);
            }
        }
    }

    const getClass = (status: string | undefined) => {
        if (undefined != status) {
            if (CUSTOMER_VERIFICATION_STATUS.PENDING == status) {
                return 'time-line-pending';
            } else if (CUSTOMER_VERIFICATION_STATUS.VERIFIED == status) {
                return 'time-line-success'
            } else if (CUSTOMER_VERIFICATION_STATUS.RESCHEDULED == status) {
                return 'time-line-rescheduled'
            } else if (CUSTOMER_VERIFICATION_STATUS.DECLINED == status) {
                return 'time-line-declined'
            } else if (CUSTOMER_VERIFICATION_STATUS.ORIGINALLY_SEEN == status) {
                return 'time-line-success'
            } else {
                return 'time-line-rejected'
            }
        }
    }

    const getDateMonth = (inputDate: string | undefined, type: string) => {
        if (undefined != inputDate) {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

            const dateParts = inputDate.split('-');
            const year = parseInt(dateParts[0]);
            const month = parseInt(dateParts[1]) - 1; // Months in JavaScript are 0-indexed
            const day = parseInt(dateParts[2]);

            const date = new Date(year, month, day);

            const dayOfWeek = days[date.getDay()];
            const monthName = months[date.getMonth()];
            const formattedDay = day < 10 ? '0' + day : day;

            if ("dayName" === type) {
                return dayOfWeek
            } else if ("month" === type) {
                return monthName
            } else if ("day" === type) {
                return formattedDay
            }
        } else {
            return NOT_AVAILABLE;
        }

    };

    const onJoin = (link: string | undefined) => {
        if (undefined != link) {
            window.open(link, '_blank');
        }
    }

    const currentYieldNullCheck = (currentYieldDetailDto: CurrentYieldDetailDto | undefined | null) => {
        if (null != currentYieldDetailDto && undefined != currentYieldDetailDto) {
            return true;
        }
        return false
    }

    return (
        <div>
            {!isVerificationFailed ?
                <div>
                    {dashboardData.cinNumber ?
                        <FloatButton tooltip={<div>Invest Money</div>} className='invest-float-btn'
                                     onClick={navigateToInvest}
                                     icon={<img src={invest_title_img} className='card-action-btn-icon'/>}
                                     shape="square"
                        /> : <></>}
                    {/*{isLoading ?*/}
                    {/*    <div className="loader-container">*/}
                    {/*        <Spin size="large" tip={loadingMessage}></Spin>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    <Row gutter={[20, 20]}>

                        <Col xxl={8} xl={token.siderCollapsed ? 10 : 12} md={24} sm={24}>
                            <Row gutter={[20, 20]}>
                                <Col span={24}>
                                    {isLoading ?
                                        <div className="card-loader-container">
                                            <Spin size="large" tip={loadingMessage}></Spin>
                                        </div>
                                        :
                                        <>
                                            <Col span={24} style={{paddingLeft: 0, paddingRight: 0}}>
                                                <Form layout={"vertical"} className='form-input' form={form}>

                                                    <Form.Item
                                                        label=""
                                                        name={"portfolioId"}
                                                        style={{marginBottom: 20}}>
                                                        <Select className={'dashboard-portfolio-select-dropdown'}
                                                                size={'large'}
                                                                style={{width: '100%'}}
                                                                placeholder="Select a portfolio"
                                                                optionFilterProp="children"
                                                                options={portfolioNumberList?.map((portfolio) => ({
                                                                    value: portfolio.value.portfolioId,
                                                                    label: portfolio.label,
                                                                }))}
                                                                onChange={onPortfolioIdChange}
                                                        />
                                                    </Form.Item>
                                                </Form>
                                            </Col>

                                            <Col span={24} style={{paddingLeft: 0, paddingRight: 0}}>
                                                {/*{isLoading ?*/}
                                                {/*    <div className="card-loader-container">*/}
                                                {/*        <Spin size="large" tip={loadingMessage}></Spin>*/}
                                                {/*    </div>*/}
                                                {/*    :*/}
                                                <Spin spinning={isCardLoading} size="large">
                                                    {dashboardData.accountCardDetails.length > 0 ?
                                                        <AccountCardCarousal accountDetails={dashboardData}
                                                                             updateComp={updateComp}
                                                                             onEdit={onSecondApplicantEdit}/>
                                                        : <Card size={'small'}
                                                                className='dashboard-card-box-shadow'
                                                                style={{height: 250, padding: 50}}>
                                                            <Empty
                                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                description="No cards available"/>
                                                        </Card>}
                                                </Spin>

                                            </Col>
                                        </>}
                                </Col>
                                <Col span={24}>
                                    {isNoData ?
                                        <div className="wealth-loader-container">
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description="No data available"/>
                                        </div> :
                                        isTotalWealthLoading ?
                                            <div className="wealth-loader-container">
                                                <Spin size="large" tip={loadingMessage}></Spin>
                                            </div>
                                            :
                                            <Card size={'small'} className='main-card-bg-none dashboard-2-card'>
                                                <Row gutter={[16, 16]}>
                                                    <Col span={24}>
                                                        <Card className={'total-wealth-card'}>
                                                            <Row gutter={[16, 16]}>
                                                                <Col span={24}
                                                                     className={'total-wealth-card-border-right'}
                                                                     style={{
                                                                         display: 'flex',
                                                                         justifyContent: 'center',
                                                                         alignItems: 'center'
                                                                     }}>
                                                                    <div className="dashboard-info-card">
                                                                        <div className="card-icon card-1-icon">
                                                                            <FontAwesomeIcon icon={faSackDollar}/>
                                                                        </div>
                                                                        <div className="card-info">
                                                                            <h5>Your Total Wealth</h5>
                                                                            <h4><span
                                                                                className="lkr-span">LKR</span> {null == totalWealthAndCurrentYield?.totalWealth ? "0.00" : CommonFunction.decimalFormat(String(totalWealthAndCurrentYield?.totalWealth))}
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                                {/*<Col span={12}*/}
                                                                {/*     style={{*/}
                                                                {/*         display: 'flex',*/}
                                                                {/*         justifyContent: 'center',*/}
                                                                {/*         alignItems: 'center'*/}
                                                                {/*     }}>*/}
                                                                {/*    <div className="current-yield-card">*/}

                                                                {/*        <h5 className={'current-yield-title'}>Current*/}
                                                                {/*            Yield</h5>*/}
                                                                {/*        <h4 className={'yield-fund-name'}>{currentYieldNullCheck(totalWealthAndCurrentYield?.currentYieldDto) ? null == totalWealthAndCurrentYield?.currentYieldDto.fundName ? "" : totalWealthAndCurrentYield?.currentYieldDto.fundName : "N/A"}</h4>*/}
                                                                {/*        <h5 className={'cy-value'}>{currentYieldNullCheck(totalWealthAndCurrentYield?.currentYieldDto) ? null == totalWealthAndCurrentYield?.currentYieldDto.yield ? "0.00" : CommonFunction.decimalFormat(totalWealthAndCurrentYield?.currentYieldDto.yield) : "N/A"}%</h5>*/}
                                                                {/*        <h4 className={'as-at-date'}>As*/}
                                                                {/*            at {currentYieldNullCheck(totalWealthAndCurrentYield?.currentYieldDto) ? null == totalWealthAndCurrentYield?.currentYieldDto.date ? "" : CommonFunction.formatDate(totalWealthAndCurrentYield?.currentYieldDto.date.toString()) : "N/A"} </h4>*/}

                                                                {/*    </div>*/}

                                                                {/*</Col>*/}

                                                            </Row>
                                                        </Card>
                                                    </Col>

                                                </Row>
                                            </Card>
                                    }

                                </Col>
                            </Row>
                        </Col>


                        <Col xxl={16} xl={token.siderCollapsed ? 14 : 12} md={24} sm={24}>
                            <Row gutter={[20, 20]}>

                                <Col span={24}>
                                    {isPieChartLoading ?
                                        <div className="fund-viewer-loader-container">
                                            <Spin size="large" tip={loadingMessage}></Spin>
                                        </div> :
                                        <>
                                            {dashboardData.cinNumber ?
                                                <Card size={'small'} style={{height: 418}}
                                                      className='main-card-bg-none dashboard-card-box-shadow'>
                                                    {(fundData.length > 0 && !isAllZero) ?
                                                        // <FundChart fundData={fundData}/>
                                                        <GoogleChart fundData={fundData}/>
                                                        :
                                                        <Card className={'no-data-pie-chart-card'}
                                                              style={{height: 418}}>
                                                            <Empty style={{
                                                                height: 418,
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                margin: 0
                                                            }}
                                                                   image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                   description="No funds available"/>
                                                        </Card>}
                                                </Card>
                                                : isNoData ?
                                                    <Card size={'small'}
                                                          className='main-card-bg-none dashboard-card-box-shadow '>
                                                        <Card className={'no-data-pie-chart-card'}
                                                              style={{height: 418}}>
                                                            <Empty style={{
                                                                height: 418,
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                margin: 0
                                                            }}
                                                                   image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                   description="No data available"/>
                                                        </Card>
                                                    </Card>
                                                    :
                                                    <Card title={'Onboard Process Verification Status'} size={'small'}
                                                          className={'dashboard-card-box-shadow pie-chart-card-custom-padding time-line-card'}
                                                          style={{height: 418}}>
                                                        <Row>
                                                            <Col span={10} className={'dashboard-time-line'}>
                                                                <Timeline
                                                                    items={[
                                                                        {
                                                                            dot: <FileDoneOutlined
                                                                                style={{fontSize: 24}}
                                                                                className={getClass(verificationStatuses?.documentVerificationStatus)}/>,
                                                                            children: (
                                                                                <>
                                                                                    <p className={'dashboard-time-line-label'}>
                                                                                        <div
                                                                                            className={'lbl-div-width'}>Document
                                                                                            Verification
                                                                                        </div>
                                                                                        {getTag(verificationStatuses?.documentVerificationStatus)}
                                                                                    </p>

                                                                                </>
                                                                            ),
                                                                        },


                                                                        {
                                                                            dot: <VideoCameraOutlined
                                                                                style={{fontSize: 24}}
                                                                                className={getClass(verificationStatuses?.videoVerificationStatus)}/>,
                                                                            children: (
                                                                                <>
                                                                                    <p className={'dashboard-time-line-label'}>
                                                                                        <div
                                                                                            className={'lbl-div-width'}>Video
                                                                                            Verification
                                                                                        </div>
                                                                                        {getTag(verificationStatuses?.videoVerificationStatus)}
                                                                                    </p>

                                                                                    {/*<Button type="link">Click to Join to the Video Verification</Button>*/}
                                                                                </>
                                                                            ),
                                                                        },
                                                                        {
                                                                            dot: <UserOutlined style={{fontSize: 24}}
                                                                                               className={getClass(verificationStatuses?.customerVerificationStatus)}/>,
                                                                            children: (
                                                                                <>
                                                                                    <p className={'dashboard-time-line-label'}>
                                                                                        <div
                                                                                            className={'lbl-div-width'}>Customer
                                                                                            Verification
                                                                                        </div>
                                                                                        {getTag(verificationStatuses?.customerVerificationStatus)}
                                                                                    </p>

                                                                                </>
                                                                            ),
                                                                        },

                                                                    ]}
                                                                />
                                                            </Col>
                                                            {CUSTOMER_VERIFICATION_STATUS.ORIGINALLY_SEEN != verificationStatuses?.videoVerificationStatus ?
                                                                <Col span={14}>
                                                                    <Card className={'vv-info-card'}>
                                                                        <Row>

                                                                            <Col span={24}>
                                                                                <h3>Video Verification on</h3>
                                                                            </Col>
                                                                            <Col span={24}
                                                                                 className="vv-calender-card-col">
                                                                                <div className="vv-calender-card">
                                                                                    <div className={'vv-date-month'}>
                                                                    <span
                                                                        className={'vv-date'}>{getDateMonth(verificationStatuses?.videoVerificationDate, "dayName")}</span>
                                                                                        <span
                                                                                            className={'vv-month'}>{getDateMonth(verificationStatuses?.videoVerificationDate, "month")}</span>
                                                                                    </div>
                                                                                    <span
                                                                                        className={'vv-date-large'}>{getDateMonth(verificationStatuses?.videoVerificationDate, "day")}</span>
                                                                                    <span
                                                                                        className="vv-time-slot">{verificationStatuses?.timeSlot}</span>
                                                                                </div>

                                                                            </Col>
                                                                            <Col span={24}>
                                                                                <Button type="link"
                                                                                        style={{marginTop: 12}}
                                                                                        className={'vv-join-dashboard-link'}
                                                                                        onClick={() => onJoin(verificationStatuses?.videoVerificationLink)}>Click
                                                                                    here to
                                                                                    join
                                                                                    the
                                                                                    video verification</Button>
                                                                            </Col>

                                                                        </Row>
                                                                    </Card>

                                                                </Col> : <></>}
                                                        </Row>
                                                    </Card>
                                            }

                                        </>}

                                </Col>
                            </Row>
                        </Col>

                        <Col xxl={8} xl={token.siderCollapsed ? 10 : 12} md={24} sm={24}>
                            <Row gutter={[20, 20]}>

                                <Col span={24}>
                                    <Card title={'Pending Change Request'} size={'small'}
                                          className={'dashboard-card-box-shadow bottom-row-card-height pending-change-request-card'}>

                                        <PendingChangeRequest cinNumber={dashboardData.cinNumber}/>

                                    </Card>
                                </Col>
                            </Row>
                        </Col>

                        <Col xxl={16} xl={token.siderCollapsed ? 14 : 12} md={24} sm={24}>
                            <Row gutter={[20, 20]}>
                                <Col span={24}>
                                    <Card size={'small'} className='main-card-bg-none dashboard-card-box-shadow'>
                                        <TransactionSummary portfolioId={portfolioId}
                                                            accountNumber={accountNumber}
                                                            cinNumber={dashboardData.cinNumber}/>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </div> :
                <div className="loader-container">
                    <Spin size="large"></Spin>
                </div>}
        </div>
    );

}
export default DashboardPage;